'use strict';

var _regeneratorRuntime = require("C:\\Users\\chris\\Documents\\Code\\PerspectiveDeveloper\\CattlepassDapp\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator");

var _asyncToGenerator = require("C:\\Users\\chris\\Documents\\Code\\PerspectiveDeveloper\\CattlepassDapp\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/asyncToGenerator");

var CID = require('cids');

var multicodec = require('multicodec');

var multihashing = require('multihashing-async');

var multihash = multihashing.multihash;
var codec = multicodec.DAG_PB;
var defaultHashAlg = multihash.names['sha2-256'];
/**
 * @typedef {object} GenCIDOptions - Options to create the CID
 * @property {CID.CIDVersion} [cidVersion=1] - CID version number
 * @property {multihashing.multihash.HashCode} [hashAlg=multihash.names['sha2-256']] - Defaults to the defaultHashAlg of the format
 */

/**
 * Calculate the CID of the binary blob.
 *
 * @param {Uint8Array} binaryBlob - Encoded IPLD Node
 * @param {GenCIDOptions} [userOptions] - Options to create the CID
 */

var cid = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(binaryBlob) {
    var userOptions,
        options,
        hashName,
        hash,
        codecName,
        cid,
        _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            userOptions = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
            options = {
              cidVersion: userOptions.cidVersion == null ? 1 : userOptions.cidVersion,
              hashAlg: userOptions.hashAlg == null ? defaultHashAlg : userOptions.hashAlg
            };
            hashName = multihash.codes[options.hashAlg];
            _context.next = 5;
            return multihashing(binaryBlob, hashName);

          case 5:
            hash = _context.sent;
            codecName = multicodec.getNameFromCode(codec);
            cid = new CID(options.cidVersion, codecName, hash);
            return _context.abrupt("return", cid);

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function cid(_x) {
    return _ref.apply(this, arguments);
  };
}();

module.exports = {
  codec: codec,
  defaultHashAlg: defaultHashAlg,
  cid: cid
};